import {
    get,
    deleter,
    post
} from '../js/request'

// 校验证件，护照，港澳通行证
export function checkCard (params) {
	return get('https://vrhall.ccnfgame.com/zhanhui/api/exhibitionTicketCode/certificateCheck',params);
}

export function singleUserApply(data) {
    const header = {
        headers: { "Content-Type": "application/x-www-form-urlencoded" }
      };
	return post('https://vrhall.ccnfgame.com/zhanhui/api/mediaSystem/voucherUser/singleUserApply',data,header)
}

export function login(data) {
    const header = {
        headers: { "Content-Type": "application/x-www-form-urlencoded" }
      };
	return post('https://vrhall.ccnfgame.com/zhanhui/api/mediaSystem/login',data,header)
}

export function resubmit(data) {
    const header = {
        headers: { "Content-Type": "application/x-www-form-urlencoded" }
      };
	return post('http://192.168.171.2:10004/zhanhui/api/mediaSystem/voucherUser/resubmit',data,header)
}


// WEBPACK FOOTER //
// ./src/common/api/media.js